module.exports = __webpack_public_path__ + "static/media/c2.28734320.jpg";